import { SET_LIST_STAFF } from "../../assets/constants/reducer.type";
  
  export const setListStaff = (payload) => {
    return { type: SET_LIST_STAFF, payload };
  };
  